/* SUN365 catalog (sections/sun365-catalog.liquid).
   Sizes on a card, add to cart through /cart/add.js with the
   floating cart button re-rendered (section cart-icon-bubble), the free-delivery
   reminder, the line chips, and filters with sort when the section renders them.
   Without JavaScript the cards are plain forms. */
(function () {
  'use strict';

  var root = document.querySelector('[data-s365k]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-s365k-config]').textContent); } catch (e) { cfg = {}; }
  var live = root.querySelector('[data-live]');
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    function withDelims(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_with_comma_separator') return withDelims(cents, 2, '.', ',');
      if (key === 'amount_no_decimals') return withDelims(cents, 0, ',', '.');
      if (key === 'amount_no_decimals_with_comma_separator') return withDelims(cents, 0, '.', ',');
      if (key === 'amount_with_apostrophe_separator') return withDelims(cents, 2, "'", '.');
      return withDelims(cents, 2, ',', '.');
    });
  }

  function announce(text) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 50);
  }

  function variantsOf(card) {
    if (card._variants) return card._variants;
    var node = card.querySelector('[data-variants]');
    try { card._variants = JSON.parse(node.textContent); } catch (e) { card._variants = []; }
    return card._variants;
  }

  function show(el, on) { if (el) el.hidden = !on; }

  function applyVariant(card, v, keepId) {
    var img = card.querySelector('[data-img]');
    if (img && v.src) { img.src = v.src; if (v.srcset) img.srcset = v.srcset; }
    var price = card.querySelector('[data-price-text]');
    if (price) price.textContent = v.price;
    if (card.hasAttribute('data-price')) card.setAttribute('data-price', v.cents);
    var pack = card.querySelector('[data-pack]');
    if (pack) { pack.textContent = v.pack || ''; show(pack, !!v.pack); }
    card.querySelectorAll('[data-link]').forEach(function (a) { a.href = v.url; });
    if (!keepId) {
      var input = card.querySelector('[data-id]');
      if (input) input.value = v.id;
    }
    if (card.classList.contains('is-soon')) return;
    var soldout = !v.available;
    card.classList.toggle('is-soldout', soldout);
    show(card.querySelector('[data-soldout-label]'), soldout);
    show(card.querySelector('[data-add-form]'), !soldout);
    show(card.querySelector('[data-view]'), soldout);
  }

  /* Sizes on a card */
  root.querySelectorAll('[data-card-sizes]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant]');
      if (!btn || btn.disabled) return;
      var card = group.closest('[data-card]');
      var id = Number(btn.getAttribute('data-variant'));
      group.querySelectorAll('[data-variant]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      card.classList.remove('needs-size');
      show(card.querySelector('[data-msg]'), false);
      var v = variantsOf(card).filter(function (x) { return x.id === id; })[0];
      if (v) applyVariant(card, v, false);
    });
  });

  /* Free-delivery reminder */
  function updateNudge(subtotal) {
    var nudge = root.querySelector('[data-nudge]');
    if (!nudge || !cfg.threshold) return;
    var missing = cfg.threshold - subtotal;
    if (subtotal > 0 && missing > 0) {
      nudge.querySelector('[data-nudge-text]').textContent = String(cfg.nudge || '').replace('[amount]', formatMoney(missing));
      nudge.hidden = false;
    } else {
      nudge.hidden = true;
    }
  }

  function renderBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
  }

  /* Add to cart */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var card = form.closest('[data-card]');
    var msg = card.querySelector('[data-msg]');
    var id = form.querySelector('[data-id]').value;
    if (!id) {
      card.classList.add('needs-size');
      msg.textContent = cfg.choose || '';
      msg.hidden = false;
      var first = card.querySelector('[data-variant]:not([disabled])');
      if (first) first.focus();
      return;
    }
    var btn = form.querySelector('[data-add]');
    var label = btn.querySelector('[data-add-label]');
    var check = btn.querySelector('.s365k-btn__check');
    btn.disabled = true;
    msg.hidden = true;
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) throw res.body;
        renderBubble(res.body.sections);
        btn.classList.add('is-added');
        label.textContent = cfg.added || '';
        if (check) check.hidden = false;
        announce(String(cfg.addedAria || '').replace('[product]', card.getAttribute('data-name') || ''));
        window.setTimeout(function () {
          btn.classList.remove('is-added');
          label.textContent = cfg.add || '';
          if (check) check.hidden = true;
        }, 2200);
        return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateNudge(cart.items_subtotal_price || cart.total_price || 0); });
      })
      .catch(function (err) {
        msg.textContent = (err && err.description) || cfg.error || '';
        msg.hidden = false;
      })
      .then(function () { btn.disabled = false; });
  });

  /* Filters and sort (only rendered above the section's card threshold) */
  var filters = root.querySelector('[data-filters]');
  if (filters) {
    var state = { award: [], flavour: [], stock: false, sort: 'rec' };
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-line] .s365k-grid__item')).filter(function (li) {
      return li.querySelector('[data-card][data-drink]');
    });
    items.forEach(function (li, i) { li._home = li.parentNode; li._index = i; });
    var homes = items.reduce(function (list, li) { if (list.indexOf(li._home) < 0) list.push(li._home); return list; }, []);
    var filterLines = homes.reduce(function (list, grid) {
      var line = grid.closest('[data-line]');
      if (list.indexOf(line) < 0) list.push(line);
      return list;
    }, []);
    var flat = root.querySelector('[data-flat]');
    var flatGrid = root.querySelector('[data-flat-grid]');
    var panel = filters.querySelector('[data-filters-panel]');
    var openBtn = filters.querySelector('[data-filters-open]');
    var sortSel = filters.querySelector('[data-sort]');
    var toggles = Array.prototype.slice.call(filters.querySelectorAll('[data-facet]'));
    var chipsNav = root.querySelector('[data-chips]');

    function cardOf(li) { return li.querySelector('[data-card]'); }
    function matches(card, skip) {
      if (skip !== 'award' && state.award.length && state.award.indexOf(card.getAttribute('data-award')) < 0) return false;
      if (skip !== 'flavour' && state.flavour.length && state.flavour.indexOf(card.getAttribute('data-flavour')) < 0) return false;
      if (skip !== 'stock' && state.stock && card.getAttribute('data-buyable') !== 'true') return false;
      return true;
    }
    function countFor(t) {
      var facet = t.getAttribute('data-facet');
      var value = t.getAttribute('data-value');
      return items.filter(function (li) {
        var card = cardOf(li);
        if (!matches(card, facet)) return false;
        if (facet === 'award') return card.getAttribute('data-award') === value;
        if (facet === 'flavour') return card.getAttribute('data-flavour') === value;
        return card.getAttribute('data-buyable') === 'true';
      }).length;
    }

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var ok = matches(cardOf(li));
        li.hidden = !ok;
        if (ok) shown += 1;
      });
      if (state.sort === 'price') {
        items.slice().sort(function (a, b) {
          var d = Number(cardOf(a).getAttribute('data-price')) - Number(cardOf(b).getAttribute('data-price'));
          return d || a._index - b._index;
        }).forEach(function (li) { flatGrid.appendChild(li); });
        flat.hidden = false;
        root.classList.add('is-flat');
      } else if (!flat.hidden) {
        items.slice().sort(function (a, b) { return a._index - b._index; }).forEach(function (li) { li._home.appendChild(li); });
        flat.hidden = true;
        root.classList.remove('is-flat');
      }
      homes.forEach(function (grid) {
        var row = grid.closest('[data-sizerow]');
        if (row) row.hidden = state.sort === 'price' || !grid.querySelector('.s365k-grid__item:not([hidden])');
      });
      filterLines.forEach(function (line) {
        var empty = state.sort === 'price' || !line.querySelector('.s365k-grid__item:not([hidden])');
        line.hidden = empty;
        if (chipsNav) {
          var chip = chipsNav.querySelector('[data-chip="' + line.id + '"]');
          if (chip) chip.parentNode.hidden = empty;
        }
      });
      if (chipsNav) chipsNav.hidden = state.sort === 'price';
      filters.querySelectorAll('[data-shown]').forEach(function (el) { el.textContent = shown; });
      toggles.forEach(function (t) {
        var facet = t.getAttribute('data-facet');
        var value = t.getAttribute('data-value');
        var on = facet === 'stock' ? state.stock : state[facet].indexOf(value) >= 0;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        var count = t.querySelector('[data-count]');
        if (count) count.textContent = countFor(t);
      });
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var facet = t.getAttribute('data-facet');
        var value = t.getAttribute('data-value');
        if (facet === 'stock') state.stock = !state.stock;
        else {
          var at = state[facet].indexOf(value);
          if (at >= 0) state[facet].splice(at, 1); else state[facet].push(value);
        }
        apply();
      });
    });
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
    filters.querySelector('[data-filters-clear]').addEventListener('click', function () {
      state.award = []; state.flavour = []; state.stock = false; state.sort = 'rec'; sortSel.value = 'rec';
      apply();
    });

    /* Phone: the same controls open as a bottom sheet */
    function closeSheet() {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('s365k-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
    openBtn.addEventListener('click', function () {
      panel.classList.add('is-open');
      document.documentElement.classList.add('s365k-lock');
      openBtn.setAttribute('aria-expanded', 'true');
      var title = panel.querySelector('#s365k-filters-h');
      if (title) title.focus();
    });
    filters.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    panel.addEventListener('click', function (e) { if (e.target === panel) closeSheet(); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

    /* sizes change prices: keep the price sort true */
    root.addEventListener('click', function (e) {
      if (state.sort === 'price' && e.target.closest('[data-variant]')) window.setTimeout(apply, 0);
    });
    apply();
  }

  /* Line chips: current section and the stuck state */
  var chips = root.querySelector('[data-chips]');
  if (chips && 'IntersectionObserver' in window) {
    var links = Array.prototype.slice.call(chips.querySelectorAll('[data-chip]'));
    var lines = links.map(function (a) { return document.getElementById(a.getAttribute('data-chip')); }).filter(Boolean);
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (a) {
          if (a.getAttribute('data-chip') === entry.target.id) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    lines.forEach(function (l) { spy.observe(l); });
    var sentinel = root.querySelector('[data-chips-sentinel]');
    if (sentinel) {
      new IntersectionObserver(function (entries) {
        chips.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }).observe(sentinel);
    }
  }
})();
